import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Chip from '@mui/material/Chip';

function UsersTabs(props) {
	const { value, usersCount, accessGroupsCount, onChange } = props;

	return (
		<Tabs
			onChange={onChange}
			value={value || 'users'}
			sx={{ px: 3 }}
			variant="scrollable"
		>
			<Tab
				icon={<Chip label={usersCount} size="small" variant="soft" />}
				iconPosition="end"
				label="Users"
				sx={{ minHeight: 'auto' }}
				tabIndex={0}
				value="users"
			/>

			<Tab
				icon={<Chip label={accessGroupsCount} size="small" variant="soft" />}
				iconPosition="end"
				label="Access Groups"
				sx={{ minHeight: 'auto' }}
				tabIndex={0}
				value="access-groups"
			/>
		</Tabs>
	);
}

export { UsersTabs };
